/**
 * Shared Application Bundle
 */

import '../app/modules/i18n/translation-registry.js';
import '../app/modules/i18n/translation-applier.js';
import '../app/modules/i18n/translation-loader.js';

import '../app/params.js';
import '../app/funcs.js';
import '../core/hyperLogger.js';
import '../app/auth.js';
import '../lib/userSettings.js';

import '../app/modules/lang/language-manager.js';

import '../app/modules/notifications/notification-manager.js';
import '../app/modules/notifications/toast-manager.js';
import '../app/modules/notifications/panel-manager.js';
import '../app/modules/messages/feedback-modal.js';

import '../app/modules/auth/user-menu.js';

console.log('Common Bundle Loaded');
